/**
 * [READ ONLY STORE]
 *
 * Navigation Bar Global Data
 */

import navData from "~/data/nav-bar.yaml";

export const state = () => {
    return navData.items.map((item, index) => {
        // Add indexes to sub items
        if (item.items) {
            item.items = item.items.map((item, index) => {
                return { index, ...item };
            });
        }

        // Add index to top level
        return { index, ...item };
    });
};
